import { API_V2 } from '@shared/constants/config';
import getQueryString from '@shared/utils/get-query-string';

import axios from 'axios';

function storeStudentRecommendation(topicId, userId, onSuccess, onFail) {
  axios
    .post(
      `${API_V2}/api/user/topic/rec`,
      new URLSearchParams({
        topic_id: topicId,
        user_id: userId,
      })
    )
    .then(response => onSuccess(response.data))
    .catch(error => onFail(error.response));
}

function storeIncome(topicId, userId, incomeType, onSuccess, onFail) {
  axios
    .post(
      `${API_V2}/api/income`,
      new URLSearchParams({
        topic_id: topicId,
        user_id: userId,
        income_type: incomeType,
      })
    )
    .then(response => onSuccess(response.data))
    .catch(error => onFail(error.response));
}

function getIncomeByUserId(userId, onSuccess, onFail) {
  axios
    .get(
      `${API_V2}/api/income/${getQueryString({
        user_id: userId,
      })}`
    )
    .then(response => onSuccess(response.data.data))
    .catch(() => onFail(0));
}

function getPolusCompetence(user, onSuccess, onFail) {
  axios
    .get(
      `${API_V2}/api/polus/competence${getQueryString({
        user: user,
      })}`
    )
    .then(response => onSuccess(response.data.data))
    .catch(error => onFail(error.response));
}

function getPolusSkills(user, competence, onSuccess, onFail) {
  axios
    .get(
      `${API_V2}/api/polus/skills${getQueryString({
        user: user,
        competence: competence,
      })}`
    )
    .then(response => onSuccess(response.data.data))
    .catch(error => onFail(error.response));
}

function getPolusRecommendations(user, skills, onSuccess, onFail) {
  axios
    .get(
      `${API_V2}/api/polus/recommendations${getQueryString({
        user: user,
        skills: skills,
      })}`
    )
    .then(response => onSuccess(response.data.data))
    .catch(error => onFail(error.response));
}

function findUserReview(user, onSuccess, onFail) {
  axios
    .get(`${API_V2}/api/polus/review${getQueryString({ user: user })}`)
    .then(response => onSuccess(response.data.data))
    .catch(error => onFail(error.response));
}

function findUserReport(user, onSuccess, onFail) {
  axios
    .get(`${API_V2}/api/polus/report${getQueryString({ user: user })}`)
    .then(response => onSuccess(response.data.data))
    .catch(error => onFail(error.response));
}

function getUserDoc(user, onSuccess, onFail) {
  axios
    .get(`${API_V2}/api/polus/doc${getQueryString({ user: user })}`)
    .then(response => onSuccess(response.data.data))
    .catch(error => onFail(error.response));
}

export {
  storeStudentRecommendation,
  storeIncome,
  getIncomeByUserId,
  getPolusCompetence,
  getPolusSkills,
  getPolusRecommendations,
  findUserReview,
  findUserReport,
  getUserDoc,
};
